/** Signed-in Accueil. "/" is the public landing only. */
export const APP_HOME_PATH = '/home';
/** NOTIF1 T16: Accueil dashboard. */
export const HOME_SECTION = Object.freeze({ TO_HANDLE: 'a-traiter', TODAY: 'aujourdhui' });
export const HOME_ACTIONS_MAX = 3;
export const TODAY_SKELETON_ROWS = 3;
/** Ctrl/⌘K "relancer tout le monde" → Accueil opens the composer for every pending family. */
export const RELANCE_ALL = 'all';
